/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".train-title[_ngcontent-%COMP%]{font-weight:700;margin-right:10px}.train-selected[_ngcontent-%COMP%]{color:var(--color-dark-blue)}.total[_ngcontent-%COMP%]{color:red;font-weight:600;text-align:right}.recap-menu[_ngcontent-%COMP%]{margin-bottom:20px}[_nghost-%COMP%]     .button-action .mat-raised-button{z-index:999}[_nghost-%COMP%]     .material-icons{vertical-align:middle}[_nghost-%COMP%]     .mat-raised-button:enabled{background-color:var(--color-dark-blue)!important}[_nghost-%COMP%]     .mat-tab-group{margin-top:-40px}"];
export { styles as styles };
